import React from "react";

export default function ChartLoader({ className = "", height = 64 }) {
    return (
        <div className={`flex items-center justify-center ${className}`} style={{ height }}>
            <svg
                viewBox="0 0 200 60"
                className="w-full max-w-[200px]"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <polyline
                    points="0,50 20,48 40,42 60,45 80,35 100,38 120,28 140,22 160,18 180,10 200,5"
                    stroke="url(#loaderGradient)"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="chart-line-draw"
                />
                <defs>
                    <linearGradient id="loaderGradient" x1="0" y1="0" x2="200" y2="0" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stopColor="#6b7280" />
                        <stop offset="100%" stopColor="#00d4aa" />
                    </linearGradient>
                </defs>
            </svg>

            <style>{`
                .chart-line-draw {
                    stroke-dasharray: 280;
                    stroke-dashoffset: 280;
                    animation: drawChart 1.8s ease-in-out infinite;
                }

                @keyframes drawChart {
                    0% {
                        stroke-dashoffset: 280;
                        opacity: 0.3;
                    }
                    50% {
                        stroke-dashoffset: 0;
                        opacity: 1;
                    }
                    70% {
                        stroke-dashoffset: 0;
                        opacity: 1;
                    }
                    100% {
                        stroke-dashoffset: 0;
                        opacity: 0;
                    }
                }
            `}</style>
        </div>
    );
}
